module.exports = __webpack_public_path__ + "img/panelView_blueBg_3_3.e5c12817.png";